"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDhsInstallerValidationSchema = exports.installerSignUpFormConfig = exports.defaults = void 0;
const SignUpFormConfig_1 = require("Views/Partials/Components/SignUp/SignUpFormConfig");
const yup = require("yup");
const dhsInstallerHelpers_1 = require("../DhsInstaller/helpers/dhsInstallerHelpers");
const Forms_1 = require("Forms");
exports.defaults = {
    [SignUpFormConfig_1.formControlKeys.companyType]: 'Installer/Contractor',
};
exports.installerSignUpFormConfig = {
    rows: [
        {
            elements: [
                {
                    inputType: SignUpFormConfig_1.formControlTypes.input,
                    className: SignUpFormConfig_1.formControlClasses.twoInARow,
                    key: SignUpFormConfig_1.formControlKeys.firstName,
                },
                {
                    inputType: SignUpFormConfig_1.formControlTypes.input,
                    className: SignUpFormConfig_1.formControlClasses.twoInARow,
                    key: SignUpFormConfig_1.formControlKeys.lastName,
                },
            ],
        },
        {
            elements: [
                {
                    inputType: SignUpFormConfig_1.formControlTypes.input,
                    className: SignUpFormConfig_1.formControlClasses.twoInARow,
                    key: SignUpFormConfig_1.formControlKeys.company,
                },
                {
                    inputType: SignUpFormConfig_1.formControlTypes.dropdown,
                    className: SignUpFormConfig_1.formControlClasses.twoInARow,
                    key: SignUpFormConfig_1.formControlKeys.companyType,
                },
            ],
        },
        {
            elements: [
                {
                    inputType: SignUpFormConfig_1.formControlTypes.dropdown,
                    className: SignUpFormConfig_1.formControlClasses.twoInARow,
                    key: SignUpFormConfig_1.formControlKeys.numberOfEmployees,
                },
                {
                    inputType: SignUpFormConfig_1.formControlTypes.dropdown,
                    className: SignUpFormConfig_1.formControlClasses.twoInARow,
                    key: SignUpFormConfig_1.formControlKeys.jobFunction,
                },
            ],
        },
        {
            elements: [
                {
                    inputType: SignUpFormConfig_1.formControlTypes.input,
                    className: SignUpFormConfig_1.formControlClasses.twoInARow,
                    key: SignUpFormConfig_1.formControlKeys.email,
                },
                {
                    inputType: SignUpFormConfig_1.formControlTypes.dropdown,
                    className: SignUpFormConfig_1.formControlClasses.twoInARow,
                    key: SignUpFormConfig_1.formControlKeys.country,
                },
            ],
        },
        {
            elements: [
                {
                    inputType: SignUpFormConfig_1.formControlTypes.input,
                    className: SignUpFormConfig_1.formControlClasses.twoInARow,
                    key: SignUpFormConfig_1.formControlKeys.postalZipCode,
                },
                {
                    inputType: SignUpFormConfig_1.formControlTypes.dropdown,
                    className: SignUpFormConfig_1.formControlClasses.twoInARow,
                    key: SignUpFormConfig_1.formControlKeys.language,
                },
            ],
        },
        {
            elements: [
                {
                    inputType: SignUpFormConfig_1.formControlTypes.checkbox,
                    className: `${SignUpFormConfig_1.formControlClasses.oneInARow} ${SignUpFormConfig_1.formControlClasses.agreementBlock}`,
                    key: SignUpFormConfig_1.formControlKeys.consentCheckbox,
                },
            ],
        },
        {
            elements: [
                {
                    inputType: SignUpFormConfig_1.formControlTypes.submit,
                    className: SignUpFormConfig_1.formControlClasses.oneInARow,
                    key: SignUpFormConfig_1.formControlKeys.submitBtn,
                },
            ],
        },
    ],
};
const getDhsInstallerValidationSchema = (props) => yup.object({
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    company: yup.string().required(),
    companyType: yup.string().required(),
    numberOfEmployees: yup.string().required(),
    jobFunction: yup.string().required(),
    email: yup
        .string()
        .email()
        .required()
        .test(value => !(0, Forms_1.validateInfoEmail)(value)),
    country: yup
        .string()
        .required()
        .test(value => !(0, Forms_1.validateCountry)(value)),
    postalZipCode: yup.string().required(),
    language: yup.string().when('country', {
        is: country => (0, dhsInstallerHelpers_1.shouldRenderControl)({ inputType: '', className: '', key: SignUpFormConfig_1.formControlKeys.language }, props, { country }),
        then: yup.string().required(),
        otherwise: yup.string(),
    }),
    consentCheckbox: yup.boolean().oneOf([true], 'required').required(),
});
exports.getDhsInstallerValidationSchema = getDhsInstallerValidationSchema;
